import React from 'react'

export const useCommonQueryKey = () =>
  React.useMemo(() => ['UseCommonQuery_Main'], [])
